export default __webpack_public_path__ + "static/media/pictogramBeaconManage128.aa8fcea0.svg";